import { ImageGalleryPage } from "../../image-gallery/ImageGalleryPage"

export const Review = () => {
    return (
        <ImageGalleryPage />
    )
}